import { useSnapshot } from 'valtio'
import cn from 'classnames'
import { type ReactElement } from 'react'
import { TableCell } from '../../../transactions/index/TransactionsTable/TransactionsRows/TableCell'
import { customersProxy } from '../../../../../shared/proxies/customersProxy'
import { buildAppCustomerPath } from '../../../../../pages/app/customers/[id]'

export function CustomerTableRows (): ReactElement {
  const { customers } = useSnapshot(customersProxy)
  return (
    <>
      {customers.length === 0 && (
        <tr>
          <td colSpan={10}>
            <div className="text-center my-16 text-wpy-gray">
              No Results
            </div>
          </td>
        </tr>
      )}
      {customers.map((customer, i) => {
        const notLastRow = i !== (customersProxy.customers.length - 1)
        const path = buildAppCustomerPath(customer.id)
        return (
          <tr
            key={customer.id}
            className={
              cn(
                'opacity-90 my-1 text-sm animate__animated animate__fadeIn',
                notLastRow && 'border-b border-gray-100'
              )
            }
          >
            <TableCell path={path}>
              {customer.id}
            </TableCell>
            <TableCell path={path}>
              {customer.companyName}
            </TableCell>
            <TableCell path={path}>
              <div className="p-4 text-ellipsis whitespace-nowrap overflow-hidden">
                {customer.firstName} {customer.lastName}
              </div>
            </TableCell>
            <TableCell path={path}>
              <div className="p-4 text-ellipsis whitespace-nowrap overflow-hidden">
                {
                customer.addressOne
                  ? `${customer.addressOne} ${customer.city}, ${customer.state} ${customer.postalCode}`
                  : '--'
              }
              </div>
            </TableCell>
            <TableCell path={path}>
              {customer.email}
            </TableCell>
          </tr>
        )
      })}
    </>
  )
}
